import { CardContent, CardOverflow, Typography } from '@mui/joy';
import { CloudArrowUp } from '@phosphor-icons/react';
import convertSize from 'convert-size';
import { useTranslation } from 'react-i18next';

import { useBomPartsImportContext } from 'bom/states';
import { fileTypeIconMap } from 'core/constants';
import { ButtonFileUpload } from 'core/elements';
import { formatDate } from 'core/utils';
import { Color, Level, Orientation, Variant } from 'theme/enums';

import {
  CardWrapper,
  dateStyle,
  iconStyle,
  RightCardOverflow,
  RightWrapper,
  Wrapper,
} from './style';

const FileImport = () => {
  const { t } = useTranslation();
  const { acceptFileTypes, file, setFile } = useBomPartsImportContext();

  const onUpload = (file: File) => setFile(file);

  return (
    <Wrapper>
      <CardWrapper orientation={Orientation.HORIZONTAL} variant={Variant.PLAIN}>
        <CardOverflow sx={iconStyle}>{fileTypeIconMap[file?.type]}</CardOverflow>
        <CardContent>
          <Typography level={Level.TITLE_MD}>{file?.name}</Typography>
          <Typography level={Level.TITLE_SM} color={Color.NEUTRAL}>
            {convertSize(file?.size ?? 0)}
          </Typography>
          <Typography level={Level.BODY_XS} sx={dateStyle}>
            {t('labelUploadedDate', {
              date: formatDate(new Date()),
            })}
          </Typography>
        </CardContent>
        <RightCardOverflow>
          <RightWrapper>
            <ButtonFileUpload
              text={t('buttonLabelUploadDifferentFile')}
              variant={Variant.OUTLINED}
              startDecorator={<CloudArrowUp />}
              onUpload={onUpload}
              acceptTypes={Object.keys(acceptFileTypes)}
            />
          </RightWrapper>
        </RightCardOverflow>
      </CardWrapper>
    </Wrapper>
  );
};

export default FileImport;
